"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ImageContainer = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Image = styled_components_1.default.img `
  width: 100%;
  height: 100%;
  max-width: 100%;
  object-fit: cover;
`;
const FallbackImage = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background-color: ${({ color }) => color};
  opacity: 60%;
`;
const ImageComponent = ({ landscapeSrc, portraitSrc, brandInfo, children }) => {
    const [src, setSrc] = (0, react_1.useState)(portraitSrc);
    const updateImageSrc = () => {
        if (window.innerWidth > window.innerHeight) {
            setSrc(landscapeSrc);
        }
        else {
            setSrc(portraitSrc);
        }
    };
    (0, react_1.useEffect)(() => {
        updateImageSrc();
        window.addEventListener('resize', updateImageSrc);
        return () => {
            window.removeEventListener('resize', updateImageSrc);
        };
    }, [landscapeSrc, portraitSrc]);
    return (react_1.default.createElement(ImageContainer, null,
        src ? react_1.default.createElement(Image, { src: src, alt: "Responsive Content" }) : react_1.default.createElement(FallbackImage, { color: brandInfo.colorSecondary }),
        children));
};
exports.default = ImageComponent;
